import React, { useState, useEffect } from 'react';
import AnyChart from 'anychart-react';
import axios from "axios";
import anychart from "anychart";
import { Link } from "react-router-dom";
import PdmcUsecaseSidebar from "../Common/PdmcUsecaseSidebar";


const PdmcAnalyticC = () => {
  const [chart, setChart] = useState(null);
  const [data, setData] = useState([]);

  const [cropGroupData, setCropGroupData] = useState([]);
  const [cropNameData, setCropNameData] = useState([]);
  const [cropVarietyData, setCropVarietyData] = useState([])

  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [subDistrictData, setSubDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [villageData, setVillageData] = useState([]);

 
  const [cropGroupValue, setCropGroupValue] = useState("");
  const [cropNameValue, setCropNameValue] = useState("");
  const [cropVarietyValue, setCropVarietyValue] = useState("")

  const [typeOfIrrigation, setTypeOfIrrigation] = useState("");
  const [typeOfSubIrrigation, setTypeOfSubIrrigation] = useState("");
  const [yearValue, setYearValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [districtValue, setDistrictValue] = useState("");
  const [subDistrictValue, setSubDistrictValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [villageValue, setVillageValue] = useState("");

  // useEffect(() => {
 
  //   fetchData();
  // }, []);

  const fetchData = async (value) => {
    const result = await axios.post(
      `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/DashboardPdmc/GetPdmcDashboardSunBurstAreaDetails`,
      {
        "finYear": value === "reset" ? "" : yearValue,
"cropGroupCode":  value === "reset" ? "" : cropGroupValue,
"cropNameCode":  value === "reset" ? "" : cropNameValue,
"stateLgdCode":  value === "reset" ? "" : stateValue,
"districtLgdCode":   value === "reset" ? "" : districtValue,
"blockLgdCode":  value === "reset" ? "" : blockValue,
"villageLgdCode":  value === "reset" ? "" : villageValue,
"TypeOfIrrigation": value === "reset" ? "" : typeOfIrrigation,
"TypeOfSubIrrigation": value === "reset" ? "" : typeOfSubIrrigation


      }
    );
if(result) {
  setData(result.data.dataContent)

  let dataTree = anychart.data.tree(result.data.dataContent, "as-table");
  let chartInstance = anychart.sunburst(dataTree);

  // set calculation mode
  chartInstance.calculationMode("parent-independent");
   chartInstance.fill(getRandomColor);

  // set custom palette
  chartInstance.palette(["#0288d1", "#d4e157", "#ff6e40", "#f8bbd0"]);

  // format chart labels
  chartInstance.labels().format("{%Name}\n{%Value}{scale:(10000)(1)|( k)}" + " " +"Ha");

  // format chart tooltip
  chartInstance.tooltip().format("{%Name}: {%Value}{scale:(10000)(1)|( k)}");

  // set container id for the chart
  chartInstance.container("container");

  // initiate chart drawing
  setChart(chartInstance.draw());

  // Clean-up function
  return () => {
    if (chart) {
      chart.dispose(); // Dispose the chart when component unmounts
    }
  };

}
  
   
  };

  // var data = [
  //   {
  //     "id": "root",
  //     "name": "Total Area",
  //     "parent": null,
  //     "label": null,
  //     "value": "",
  //     "fill" : "#fff" ,
  //     "recCount": null
  // },
  // {
  //     "id": "MI",
  //     "name": "Micro Irrigation",
  //     "parent": "root",
  //     "label": null,
  //     "value": 344,
  //     "recCount": null,
  //     "fill" : "#eedd82" 
  // },
  // {
  //     "id": "OI",
  //     "name": "Other Interventions",
  //     "parent": "root",
  //     "label": null,
  //     "value": 100,
  //     "recCount": null,
  //     "fill" : "#eedd54" 
  // },
  // {
  //     "id": "MI_1",
  //     "name": "Cereals  ",
  //     "parent": "MI",
  //     "label": null,
  //     "value": 8,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_3",
  //     "name": "Cash crops",
  //     "parent": "MI",
  //     "label": null,
  //     "value": 252,
  //     "recCount": 3
  // },
  // {
  //     "id": "MI_5",
  //     "name": "Fiber crops",
  //     "parent": "MI",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_7",
  //     "name": "Fruits",
  //     "parent": "MI",
  //     "label": null,
  //     "value": 70,
  //     "recCount": 2
  // },
  // {
  //     "id": "MI_9",
  //     "name": "Oilseeds",
  //     "parent": "MI",
  //     "label": null,
  //     "value": 2,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_1_2",
  //     "name": "Wheat",
  //     "parent": "MI_1",
  //     "label": null,
  //     "value": 8,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_3_29",
  //     "name": "Almond",
  //     "parent": "MI_3",
  //     "label": null,
  //     "value": 6,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_3_32",
  //     "name": "Cashew",
  //     "parent": "MI_3",
  //     "label": null,
  //     "value": 246,
  //     "recCount": 2
  // },
  // {
  //     "id": "MI_5_48",
  //     "name": "Diploid cotton",
  //     "parent": "MI_5",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_7_76",
  //     "name": "Banana",
  //     "parent": "MI_7",
  //     "label": null,
  //     "value": 52,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_7_102",
  //     "name": "Blueberry",
  //     "parent": "MI_7",
  //     "label": null,
  //     "value": 18,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_9_154",
  //     "name": "Safflower",
  //     "parent": "MI_9",
  //     "label": null,
  //     "value": 2,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_7_102_1",
  //     "name": "Drip",
  //     "parent": "MI_7_102",
  //     "label": null,
  //     "value": 18,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_9_154_1",
  //     "name": "Drip",
  //     "parent": "MI_9_154",
  //     "label": null,
  //     "value": 2,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_1_2_2",
  //     "name": "Sprinkler",
  //     "parent": "MI_1_2",
  //     "label": null,
  //     "value": 8,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_3_29_1",
  //     "name": "Drip",
  //     "parent": "MI_3_29",
  //     "label": null,
  //     "value": 6,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_3_32_1",
  //     "name": "Drip",
  //     "parent": "MI_3_32",
  //     "label": null,
  //     "value": 50,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_3_32_2",
  //     "name": "Sprinkler",
  //     "parent": "MI_3_32",
  //     "label": null,
  //     "value": 196,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_5_48_1",
  //     "name": "Drip",
  //     "parent": "MI_5_48",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "MI_7_76_1",
  //     "name": "Drip",
  //     "parent": "MI_7_76",
  //     "label": null,
  //     "value": 52,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_1",
  //     "name": "Cereals  ",
  //     "parent": "OI",
  //     "label": null,
  //     "value": 20,
  //     "recCount": 2
  // },
  // {
  //     "id": "OI_2",
  //     "name": "Pulses  ",
  //     "parent": "OI",
  //     "label": null,
  //     "value": 16,
  //     "recCount": 2
  // },
  // {
  //     "id": "OI_4",
  //     "name": "Commercial crops",
  //     "parent": "OI",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_6",
  //     "name": "Flowering plant",
  //     "parent": "OI",
  //     "label": null,
  //     "value": 20,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_9",
  //     "name": "Oilseeds",
  //     "parent": "OI",
  //     "label": null,
  //     "value": 32,
  //     "recCount": 2
  // },
  // {
  //     "id": "OI_1_2",
  //     "name": "Wheat",
  //     "parent": "OI_1",
  //     "label": null,
  //     "value": 20,
  //     "recCount": 2
  // },
  // {
  //     "id": "OI_2_26",
  //     "name": "Chickpea",
  //     "parent": "OI_2",
  //     "label": null,
  //     "value": 16,
  //     "recCount": 2
  // },
  // {
  //     "id": "OI_4_47",
  //     "name": "Guarseed; Cluster Bean",
  //     "parent": "OI_4",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_6_53",
  //     "name": "Canna",
  //     "parent": "OI_6",
  //     "label": null,
  //     "value": 20,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_9_147",
  //     "name": "Indian mustard",
  //     "parent": "OI_9",
  //     "label": null,
  //     "value": 32,
  //     "recCount": 2
  // },
  // {
  //     "id": "OI_9_147_3",
  //     "name": "Water harvesting Structures",
  //     "parent": "OI_9_147",
  //     "label": null,
  //     "value": 20,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_9_147_4",
  //     "name": "Tubewells/ Borewells/ Open well",
  //     "parent": "OI_9_147",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_1_2_3",
  //     "name": "Water harvesting Structures",
  //     "parent": "OI_1_2",
  //     "label": null,
  //     "value": 8,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_1_2_5",
  //     "name": "Water Lifting devices (pumps)",
  //     "parent": "OI_1_2",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_2_26_5",
  //     "name": "Water Lifting devices (pumps)",
  //     "parent": "OI_2_26",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_2_26_4",
  //     "name": "Tubewells/ Borewells/ Open well",
  //     "parent": "OI_2_26",
  //     "label": null,
  //     "value": 4,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_4_47_4",
  //     "name": "Tubewells/ Borewells/ Open well",
  //     "parent": "OI_4_47",
  //     "label": null,
  //     "value": 12,
  //     "recCount": 1
  // },
  // {
  //     "id": "OI_6_53_3",
  //     "name": "Water harvesting Structures",
  //     "parent": "OI_6_53",
  //     "label": null,
  //     "value": 20,
  //     "recCount": 1
  // }
  // ];
let color
  function getRandomColor() {
    let arr = ["#3b9ad7", "#d89ca3", "#d8816c", "#c5c5ec", "#a78a6b", "#739666", "#85b58c", "#99d0cd", "#85c56f", "#5badda", "#d04db5", "#f2c899", "#aadeff", "#859b9f", "#686a6e", "#ae7335", "#8ad7bd", "#ffbb4f", "#c43f7c", "#eb6071", "#ed9de1", "#80de86", "#e1a4ba", "#1b70bc", "#41cae5", "#6deae0", "#de797b", "#ebc04f"];
    
    return   arr[(Math.floor(Math.random() * arr.length))]
  }


  useEffect(() => {
    // makes tree from the data for the sample
    fetchData()
 
  }, []); // Empty dependency array ensures this effect runs only once after initial render

  

  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/states`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function handleState(value) {
    setStateValue(value);
    if (value === "NA") {
      return;
    }
    setDistrictData([]);
    setDistrictValue("");
    // setSubDistrictValue("");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/district`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleSubDistrict(value, DDValue) {
    setDistrictValue(value);

    if (value === "NA") {
      return;
    }
    if (value != null) {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: value,
      });
    } else {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: districtValue,
      });
    }

    // setSubDistrictValue(value);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/subdistrict`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }
  function handleBlock(value) {
    setDistrictValue(value);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      // subdistrictcode: value,
      districtcode: value,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/block`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setBlockData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleVillage(value) {
    // setSubDistrictValue(value);
    console.log("block code", blockValue);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      blockcode: blockValue,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/village`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setVillageData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleReset() {
    setStateValue("");
    setDistrictValue("");
    setSubDistrictValue("");
    setBlockValue("");
    setVillageValue("");
    setTypeOfIrrigation("");
    setTypeOfSubIrrigation("");

    // setYearValue("");
    // setSeasonValue("");
    // setCropGroupValue("");
    // setCropNameValue("");
    // setCropVarietyValue("");

    fetchData("reset");
  }

  return (
    <>
    <PdmcUsecaseSidebar />
    <div className="page-wrapper chiller-theme toggled">
        <main id="main" className="main pdmcanalyticinner pdmcanalyticsdashboardss">
          <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
            <nav>
            <h5 className="mb-0 text-white">Per Drop More Crop (PDMC) Dashboard </h5> </nav>
            <Link className="btn btn-success btn-sm" to="/Analytics">
              Back
            </Link>
          </div>
          <div className="card pdmcreportss_card">
          <div className="card-body onbordedSchemess schemesreport pdmcreportss">
          
          <div className="row">
                

                    
                <div className="col-md-2">
                  <label htmlFor="State" className="form-label" id="StateLabel">
                    State
                  </label>
                  <select
                    id="State"
                    required
                    className="form-select"
                    onClick={getStates}
                    onChange={(e) => handleState(e.target.value)}
                    value={stateValue}
                    name="stateCode"
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {statesData
                      ? statesData.map((item, id) => {
                          return (
                            <option key={id} value={item.stateCode}>
                              {" "}
                              {item.stateName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2">
                  <label
                    htmlFor="District"
                    className="form-label"
                    id="DistrictLabel"
                  >
                    District
                  </label>
                  <select
                    id="District"
                    className="form-select"
                    onChange={(e) => handleBlock(e.target.value)}
                    value={districtValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>

                    {districtData
                      ? districtData.map((item, id) => {
                          return (
                            <option key={id} value={item.districtCode}>
                              {" "}
                              {item.districtName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                {/* <div className="col-md-2">
                        <label
                          htmlFor="subDistrict"
                          className="form-label"
                          id="subDistrictLabel"
                        >
                          SubDistrict
                        </label>
                        <select
                          id="subDistrict"
                          className="form-select"
                          onChange={(e) => handleBlock(e.target.value)}
                          value={subDistrictValue}
                        >
                          <option defaultValue value="NA">
                            Choose...
                          </option>

                          {subDistrictData.map((item, id) => {
                            return (
                              <option key={id} value={item.subDistrictCode}>
                                {" "}
                                {item.subDistrictName}
                              </option>
                            );
                          })}
                        </select>
                      </div> */}
                <div className="col-md-2">
                  <label htmlFor="Block" className="form-label" id="BlockLabel">
                    Block
                  </label>
                  <select
                    id="Block"
                    className="form-select"
                    onClick={handleVillage}
                    onChange={(e) => setBlockValue(e.target.value)}
                    value={blockValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {blockData
                      ? blockData.map((item, id) => {
                          return (
                            <option key={id} value={item.blockCode}>
                              {" "}
                              {item.blockName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="inputVillage" className="form-label">
                    Village
                  </label>
                  <select
                    id="Village"
                    className="form-select"
                    // onClick={handleVillage}
                    onChange={(e) => setVillageValue(e.target.value)}
                    value={villageValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {villageData
                      ? villageData.map((item, id) => {
                          return (
                            <option key={id} value={item.villageCode}>
                              {" "}
                              {item.villageName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2">
                        <label htmlFor="year" className="form-label">
                          Financial Year
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => setYearValue(e.target.value)}
                          value = {yearValue}
                        >
                          <option defaultValue>Choose...</option>
                          <option value="17">2021-2022</option>
                          <option value="18">2022-2023</option>
                          <option value="19">2023-2024</option>
                        </select>
                      </div>  
                      <div className="col-md-2">
                        <label htmlFor="irrigation" className="form-label">
                          Type of irrigation
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => setTypeOfIrrigation(e.target.value)}
                          value = {typeOfIrrigation}
                        >
                          <option defaultValue>Choose...</option>
                          <option value="MI">Micro Irrigation</option>
                          <option value="OI">Other Interventions</option>
                         
                        </select>
                      </div>  
                      <div className="col-md-3">
                        <label htmlFor="subIrrigation" className="form-label">
                          Type of Sub-irrigation
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => setTypeOfSubIrrigation(e.target.value)}
                          value = {typeOfSubIrrigation}
                        >
                          <option defaultValue>Choose...</option>

                          {
                            typeOfIrrigation === "MI" ? <>
                                <option value="1">Drip</option>
                          <option value="2">Sprinkler</option>
                         
                            </> : 
                            
                              typeOfIrrigation === "OI" ? <>
                          <option value="3">Water harvesting Structures</option>
                          <option value="4">Tubewells/ Borewells/ Open well</option>
                          <option value="5">Water Lifting devices (pumps)</option>
                          <option value="6">Pipes/ Pre-cast distribution system</option>
                              </> : <>
                              </>
                             
                         
                            
                          }

 
                        
                        </select>
                      </div>  
                <div className="col-md-2 mt-4 filterbtn">
                  <button
                    type="submit"
                    className="btn btn-submit btn-success"
                    onClick={fetchData}
                  >
                    Filter
                  </button>{" "}
                  &nbsp;
                  <button
                    type="submit"
                    className="btn btn-outline-secondary"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body onbordedSchemess schemesreport">
          <h3>Crop Wise and Irrigation Type Wise Report</h3>
            <div className='row'>
              <div className='col-md-12'>
              <AnyChart instance={chart} title="" />

              </div>

            </div>
          </div>
        </div>
        </main>
        </div>


    </>
    
  );
};

export default PdmcAnalyticC;
